import { Flex } from '@banhala/ui-kit';
import { useWebBaseURL } from 'shared/src/hooks';
import { isNil } from 'shared/src/utils';
import { useMemo } from 'react';
import { WebView } from 'shared/src/component/WebWebView';

export const LikeWebView = ({ url }: { url?: string }) => {
  const webBaseUrl = useWebBaseURL();

  const resolvedUrl = useMemo(() => {
    if (isNil(url) || isNil(webBaseUrl)) return undefined;
    const parsed = new URL(url, webBaseUrl);
    parsed.searchParams.set('global_layout', 'app');
    return parsed.toString();
  }, [url, webBaseUrl]);

  if (isNil(resolvedUrl)) return null;

  return (
    <Flex flex={1}>
      <WebView style={{ flex: 1 }} source={{ uri: resolvedUrl }} />
    </Flex>
  );
};
